import formatCurrency from 'format-currency';
import parsePhoneNumber from 'libphonenumber-js';
import { findPhoneNumbersInText } from 'libphonenumber-js';

import { getDistanceMessage } from '../services';

export function getProductServicesArray(item, selectedServiceIndex, provider, externalrequest) {
	var serviceArray = [];
	var optionalServiceArray = [];
	var i = 0;
 
	function FeeMessage(location) {
		var FeeMessage = 'Fee: $' + formatCurrency(location.Fee);
		if (location.Fee == 0 || location.Fee == undefined) {
			FeeMessage = '';
		}
		return FeeMessage;
	}

	function DeliveryMinutes(location) {

	 	 
		var DeliveryMessage = 'Within 24 hours';
		// If Mobile Driver Offline or Non Mobile Location use Delivery ETA Message
		if( location.OnFleetStatus  ? location.OnFleetStatus : 0  ==  0 ){
			DeliveryMessage = location.ETAMessage ? location.ETAMessage : DeliveryMessage

		}
		if( location.OnFleetStatus  ? location.OnFleetStatus : 0  ==  1 &&  location.ETAMessage == null){
		
			const leadTime = location.LeadTimeMinutes ? location.LeadTimeMinutes + 40 : 90; // HardCode add to ETA for now.
			const deliveryMinutes = leadTime + Math.ceil(location.DistanceMiles * 1.5);
		 	if (deliveryMinutes > 0) {
				DeliveryMessage = `est. ${deliveryMinutes} min*`;
			}
		}
			

			
		

		return DeliveryMessage;
	}

		if (item.priceOnlyLocations && item.priceOnlyLocations.length > 0) {
		serviceArray.push({
			Index: i,
			ServiceId: item.priceOnlyLocations[0].ServiceId,
			ServiceDescription: `Please Select Service Level Below:`,
			ServiceLabel: `Availabile in: ${DeliveryMinutes(item.priceOnlyLocations[0])}`,
			ServiceURL: `Schedule`,
			Locations: item.priceOnlyLocations,
			iconClassName: 'fas fa-car-mechanic',
			ProviderMessage: item.priceOnlyLocations[0].Message,
			DisableCart: false,
			DisableButton: true,
			ButtonLabel: `Request Service`,
			FeeMessage: item.priceOnlyLocations[0].Fee ? `${FeeMessage(item.roadsideLocations[0])}` : '',
			Fee: item.priceOnlyLocations[0].Fee ? item.priceOnlyLocations[0].Fee : 0,
			isShowPriceOnly: true
		});
		i++;
	}

	if (item.shippingLocations && item.shippingLocations.length > 0) {
		const quantityLabel = quantityLabelFunc(item.shippingLocations[0]);
		serviceArray.push({
			Index: i,
			ServiceId: item.shippingLocations[0].ServiceId,
			ServiceDescription: item.shippingLocations[0].ServiceDescription,
			ServiceLabel: `From: ${item.shippingLocations[0].City}, ${item.shippingLocations[0].State} ${quantityLabel}`,

			ProviderMessage: item.shippingLocations[0].Message,
			Locations: item.shippingLocations,
			ServiceURL: ``,
			iconClassName: 'fas fa-truck-loading',
			DisableCart: false,
			ButtonLabel: 'Buy Now',
			FeeMessage: null,
			Fee: item.shippingLocations[0].Fee ? item.shippingLocations[0].Fee : 0,
		});
		i++;
	}
	if (item.installLocations && item.installLocations.length > 0) {
		serviceArray.push({
			Index: i,
			ServiceId: item.installLocations[0].ServiceId,
			ServiceDescription: `${item.installLocations[0].ServiceDescription} in ${item.installLocations[0].City}`,
			ServiceLabel: `${getDistanceMessage(item.installLocations[0].DistanceMiles)}`,
			ServiceURL: `View Locations`,
			Name: item.installLocations[0].Name,
			ImageUrl: item.installLocations[0].ImageUrl,
			ProviderMessage: item.installLocations[0].Message,
			Locations: item.installLocations,
			iconClassName: 'fas fa-car-mechanic',
			DisableCart: false,
			ButtonLabel: `Schedule Install`,
			FeeMessage: `${FeeMessage(item.installLocations[0])} Installation`,
			Fee: item.installLocations[0].Fee ? item.installLocations[0].Fee : 0,
			//     ServiceMessage: installLocations[0].Message
		});
		i++;
	}

	if (item.repairLocations && item.repairLocations.length > 0) {
		serviceArray.push({
			Index: i,
			ServiceId: item.repairLocations[0].ServiceId,
			ServiceDescription: item.repairLocations[0].ServiceDescription,
			ServiceLabel: `${getDistanceMessage(item.repairLocations[0].DistanceMiles)}`,
			ServiceURL: `View Locations`,
			Locations: item.repairLocations,
			Name: item.repairLocations[0].Name,

			ImageUrl: item.repairLocations[0].ImageUrl,
			ProviderMessage: item.repairLocations[0].Message,
			iconClassName: 'fas fa-tools',
			DisableCart: false,
			ButtonLabel: 'Add Repair',
			ServiceMessage: item.repairLocations[0].Message,
			FeeMessage: `${FeeMessage(item.repairLocations[0])} Repair`,
			Fee: item.repairLocations[0].Fee ? item.repairLocations[0].Fee : 0,
		});
		i++;
	}


	if (item.mobileRepairLocations && item.mobileRepairLocations.length > 0) {
		serviceArray.push({
			Index: i,
			ServiceId: item.mobileRepairLocations[0].ServiceId,
			ServiceDescription: item.mobileRepairLocations[0].ServiceDescription,
			ServiceLabel: `${getDistanceMessage(item.mobileRepairLocations[0].DistanceMiles)}`,
			ServiceURL: `Schedule`,
			Locations: item.mobileRepairLocations,
			Name: "",
			ImageUrl: item.mobileRepairLocations[0].ImageUrl,
			ProviderMessage: item.mobileRepairLocations[0].Message,
			iconClassName: 'fas fa-car-mechanic',
			DisableCart: false,
			ButtonLabel: 'Add Mobile Repair',
			ServiceMessage: item.mobileRepairLocations[0].Message,
			//FeeMessage: `${FeeMessage(item.mobileRepairLocations[0])} Repair`,
			//Fee: item.mobileRepairLocations[0].Fee ? item.mobileRepairLocations[0].Fee : 0,
		});
		i++;
	}


	if (item.pickupLocations && item.pickupLocations.length > 0) {
		serviceArray.push({
			Index: i,
			ServiceId: item.pickupLocations[0].ServiceId,
			ServiceDescription: `${item.pickupLocations[0].ServiceDescription} in ${item.pickupLocations[0].City}`,
			ServiceLabel: `${getDistanceMessage(item.pickupLocations[0].DistanceMiles)}`,
			ServiceURL: `View Locations`,
			Locations: item.pickupLocations,
			iconClassName: 'fas fa-hand-holding-box',

			ImageUrl: item.pickupLocations[0].ImageUrl,
			Name: item.pickupLocations[0].Name,
			ProviderMessage: item.pickupLocations[0].Message,
			DisableCart: false,
			ButtonLabel: 'Reserve Item for Pickup',
			ServiceMessage: item.pickupLocations[0].Message,
			FeeMessage: `${FeeMessage(item.pickupLocations[0])} Pickup`,
			Fee: item.pickupLocations[0].Fee ? item.pickupLocations[0].Fee : 0,
		});
		i++;
	}

	if (item.deliveryLocations && item.deliveryLocations.length > 0) {
		serviceArray.push({
			Index: i,
			ServiceId: item.deliveryLocations[0].ServiceId,
			ServiceDescription: `${item.deliveryLocations[0].ServiceDescription} ${
				item.deliveryLocations[0].ServiceId == 2 ? ' - No Install' : ''
			}`,
			ServiceLabel: `${DeliveryMinutes(item.deliveryLocations[0])}`,
			ServiceURL: `Schedule`,
			Locations: item.deliveryLocations,
			iconClassName: 'fas fa-car-mechanic',
			ProviderMessage: item.deliveryLocations[0].Message,
			DisableCart: false,
			ButtonLabel:
				`Schedule Install`,
			FeeMessage: `${FeeMessage(0)}`,
			Fee: item.deliveryLocations[0].Fee ? 0 : 0,
		});
		i++;
	}


	if (item.deliveryOnlyLocations && item.deliveryOnlyLocations.length > 0) {
		serviceArray.push({
			Index: i,
			ServiceId: item.deliveryOnlyLocations[0].ServiceId,
			ServiceDescription: `${item.deliveryOnlyLocations[0].ServiceDescription} ${
				item.deliveryOnlyLocations[0].ServiceId == 2 ? '' : ''
			}`,
			ServiceLabel: `${DeliveryMinutes(item.deliveryOnlyLocations[0])}`,
			ServiceURL: `Schedule`,
			Locations: item.deliveryOnlyLocations,
			iconClassName: 'fas fa-truck',
			ProviderMessage: item.deliveryOnlyLocations[0].Message,
			DisableCart: false,
			ButtonLabel:
				externalrequest && externalrequest.request
					? `${externalrequest.request.serviceNeeded} Upgrade`
					: `Schedule Delivery`,
			FeeMessage: `${FeeMessage(0)}`,
			Fee: item.deliveryOnlyLocations[0].Fee ? 0 : 0,
		});
		i++;
	}


	if (item.roadsideLocations && item.roadsideLocations.length > 0) {
		serviceArray.push({
			Index: i,
			ServiceId: item.roadsideLocations[0].ServiceId,
			ServiceDescription: `${item.roadsideLocations[0].ServiceDescription}`,
			ServiceLabel: `Availabile in: ${DeliveryMinutes(item.roadsideLocations[0])}`,
			ServiceURL: `Schedule`,
			Locations: item.roadsideLocations,
			iconClassName: 'far fa-ambulance',
			ProviderMessage: item.roadsideLocations[0].Message,
			DisableCart: false,
			ButtonLabel: `Request Service`,
			FeeMessage: item.roadsideLocations[0].Fee ? `${FeeMessage(item.roadsideLocations[0])}` : '',
			Fee: item.roadsideLocations[0].Fee ? item.roadsideLocations[0].Fee : 0,
		});
		i++;
	}

	var phoneNumber = '';
	var googleNumber = '';
	// No Service Items Check for Call Only Locations ( Note UI should have Button Change based on  Service - Example.
	// Call Only is simply a Tel Link, INstall and Shipping Add to Cart, Roadside different Checkout Process)
	const callCount = item.callLocations ? item.callLocations.length : 0;
	if (callCount > 0) {
		if (item.callLocations[0].PhoneNumber) {
			googleNumber = findPhoneNumbersInText(item.callLocations[0].PhoneNumber, 'US');
			phoneNumber = item.callLocations[0].PhoneNumber;
			if (googleNumber.length > 0) {
				googleNumber = parsePhoneNumber(googleNumber[0].number.number);
				phoneNumber = googleNumber.formatNational();
				googleNumber = googleNumber.getURI();
			}
		}

		serviceArray.push({
			Index: i,
			ServiceId: item.callLocations[0].ServiceId,
			ServiceDescription: item.callLocations[0].ServiceDescription,
			ServiceLabel: `From: ${item.callLocations[0].City}, ${item.callLocations[0].State}`,
			Locations: item.callLocations,
			ServiceURL: `Please Call  ${item.callLocations[0].PhoneNumber} ${getDistanceMessage(
				item.callLocations[0].DistanceMiles
			)}`,
			iconClassName: 'fas fa-phone',
			Fee: 0,
			Name: item.callLocations[0].Name,

			ImageUrl: item.callLocations[0].ImageUrl,
			ProviderMessage: item.callLocations[0].Message,
			Reviews: null,
			DisableCart: true,
			FeeMessage: `Please Call`,
			ButtonLabel: `Please Click Button to Call`,
			PhoneNumber: phoneNumber,
			//     ServiceMessage: shippingLocations[0].Message // Provider Specific Message - Need to Fix API HERE
		});
		i++;
	}

	const affiliateCount = item.affiliateLocations ? item.affiliateLocations.length : 0;

	if (affiliateCount > 0) {
		if (item.affiliateLocations[0].PhoneNumber) {
			googleNumber = findPhoneNumbersInText(item.affiliateLocations[0].PhoneNumber, 'US');
			phoneNumber = item.affiliateLocations[0].PhoneNumber;
			if (googleNumber.length > 0) {
				googleNumber = parsePhoneNumber(googleNumber[0].number.number);
				phoneNumber = googleNumber.formatNational();
				googleNumber = googleNumber.getURI();
			}
		}

		serviceArray.push({
			Index: i,
			ServiceId: item.affiliateLocations[0].ServiceId,
			ServiceDescription: item.affiliateLocations[0].ServiceDescription,
			ServiceLabel: `${item.affiliateLocations[0].IsMobile ? 'Drivers Available' : 'Click to Start'}`,
			Locations: item.affiliateLocations,
			ServiceURL: item.affiliateLocations[0].AffliateURL,

			iconClassName: 'fas fa-link',
			Fee: 0,
			Name: item.affiliateLocations[0].Name,

			ImageUrl: item.affiliateLocations[0].ImageUrl,
			ProviderMessage: item.affiliateLocations[0].Message,
			Reviews: null,
			DisableCart: true,
			FeeMessage: null,
			ButtonLabel: `Get Started`,
			PhoneNumber: phoneNumber,
			//     ServiceMessage: shippingLocations[0].Message // Provider Specific Message - Need to Fix API HERE
		});
		i++;
	}

	if (
		serviceArray.length > 0 &&
		item.selectedProviderService &&
		(provider != undefined || item.selectedProviderService.provider != undefined)
	) {
		var myProvider = provider
			? provider.providerId
			: item.selectedProviderService
			? item.selectedProviderService.providerId.ProviderId
			: 0; // Default to first in Array and First Provider and Service ID
		var myServiceId = provider
			? provider.serviceId
			: item.selectedProviderService
			? item.selectedProviderService.serviceId
			: 0;

		const i = serviceArray.findIndex(el => el.ServiceId === myServiceId);
		selectedServiceIndex = 0;
		if (i >= 0) {
			selectedServiceIndex = i;
			const j = serviceArray[i].Locations.findIndex(el => el.ProviderId === myProvider);

			if (j >= 0) {
				item.price = serviceArray[i].Locations[j].Price;
				// TODO: Add Hourly Rate..

				const mover = serviceArray[i].Locations[j];

				serviceArray[i].Locations.splice(j, 1);

				serviceArray[i].Locations.unshift(mover);
			}
		}
	}

	// TODO: Need to Reformat Service Array Descriptions
	// Resort Service Array by Selected Service Level???
	serviceArray.forEach(function (service, i) {
		switch (service.ServiceId) {
			case 0: {
				const quantityLabel = quantityLabelFunc(service.Locations[0]);
				service.ServiceLabel = `From: ${service.Locations[0].City}, ${service.Locations[0].State} ${quantityLabel}`;
				break;
			}
			case 1:
				(service.ServiceDescription = `${service.Locations[0].ServiceDescription} in ${service.Locations[0].City}`),
					(service.ServiceLabel = `${getDistanceMessage(service.Locations[0].DistanceMiles)}`);
				break;
			case (2, 3):
				service.iconClassName = 'fas fa-shipping-fast';
				break;
			case 4:
				break;
			case 5:
				service.ServiceLabel = `Please Call: ${service.Locations[0].PhoneNumber}`;
				service.ServiceURL = `Please Call  ${service.Locations[0].PhoneNumber} ${getDistanceMessage(
					service.Locations[0].DistanceMiles
				)}`;
				break;
		}
	});

	if (serviceArray.length > 0) {
		item.selectedProviderService = {
			providerId: serviceArray[selectedServiceIndex].Locations[0],
			serviceId: serviceArray[selectedServiceIndex].ServiceId,
		};

		if (serviceArray.length > 1 || serviceArray[0].ServiceId != 0) {
			optionalServiceArray = serviceArray;
		}
	}
	return { item, serviceArray, selectedServiceIndex, optionalServiceArray };
}

function quantityLabelFunc(location) {
	return location.InventoryManaged == 1 ? `Available: ${location.Quantity}` : '';
}
